import { IServerSideGetRowsParams } from '@access-erp/common';
import { FilterValueTypes } from '@access-erp/ui-components';
import { useState } from 'react';

import { Forms } from '@/graphql/contracts/_generated_/contracts';
import { mapColumnConfigsWithSavedFilters } from '../utils/mapColumnConfigsWithSavedFilters';
import { getSavedSearch } from '../utils/savedSearch';
import useGetSavedSearchQuery from './SavedSearches/useGetSavedSearchQuery';

export const useGetInitialFiltersSet = () => {
  const [savedFilters, setSavedFilters] = useState<any[]>([]);
  const { getSavedSearchQuery } = useGetSavedSearchQuery();

  const getSavedFilterIfAny = async (formName: Forms, params: IServerSideGetRowsParams) => {
    const savedFilterKey = getSavedSearch?.()?.savedFilterData?.filterKey;

    const customerAccountNumber =
      new URL(window.location.href).searchParams.get('customerAccountNumber') ?? '';
    const salesOrderId = new URL(window.location.href).searchParams.get('salesOrderId') ?? '';
    const contractNumber = new URL(window.location.href).searchParams.get('contractNumber') ?? '';

    const invoiceToAccountNumber =
      new URL(window.location.href).searchParams.get('invoiceToAccountNumber') ?? '';
    const poNumber = new URL(window.location.href).searchParams.get('poNumber') ?? '';
    const poCurrency = new URL(window.location.href).searchParams.get('poCurrency') ?? '';

    if (invoiceToAccountNumber && poNumber && poCurrency) {
      const combinedFilter = {
        invoiceToCustomerAccountNumber: { eq: invoiceToAccountNumber },
        contractCurrency: { eq: poCurrency },
      };

      setSavedFilters(mapColumnConfigsWithSavedFilters(combinedFilter, params));
    } else if (customerAccountNumber) {
      const customerNameFilter = { customerAccountNumber: { eq: customerAccountNumber } };
      setSavedFilters(mapColumnConfigsWithSavedFilters(customerNameFilter, params));
    } else if (contractNumber) {
      const contractNumberFilter = { contractNumber: { eq: contractNumber } };
      setSavedFilters(mapColumnConfigsWithSavedFilters(contractNumberFilter, params));
    } else if (salesOrderId) {
      setSavedFilters([
        {
          name: 'salesOrderID',
          type: FilterValueTypes.ListFilter,
          label: 'SO ID',
          value: {
            eq: salesOrderId,
          },
        },
      ]);
    }

    if (savedFilterKey) {
      const rowKey = await getSavedSearchQuery({
        form: Forms[formName],
        rowKey: savedFilterKey,
      });

      const savedFilterDTO = rowKey ? JSON.parse(rowKey[0].filter!) : {};
      const savedFiltersWithMappedConfigs = mapColumnConfigsWithSavedFilters(
        savedFilterDTO,
        params,
      );

      setSavedFilters(savedFiltersWithMappedConfigs);
    }

  };

  return { savedFilters, getSavedFilterIfAny };
};
